var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CompanyProfile"},[_c('Title',{attrs:{"title":_vm.title}}),_c('div',{staticClass:"container flex flex-wrap"},[_c('div',{staticClass:"content wow fadeInLeft",attrs:{"data-wow-offset":"400"},domProps:{"innerHTML":_vm._s(_vm.column[8].content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }